<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .upload-item {
    background-color: colors.get(interfaceWhite);
    border: 1px solid colors.get(interfaceSwGrey_10);
    border-radius: 8px;
    height: 58px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 8px 8px 4px;
    position: relative;

    &.viewed {
      background-color: colors.get(interfaceSwGrey_4);
    }
  }

  .upload-item-left {
    display: flex;
    align-items: center;
    min-width: 0;
    flex: 1;
  }

  .progress-bar-container {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3px;
    background-color: colors.get(interfaceSwGrey_10);
    border-radius: 0 0 8px 8px;
    overflow: hidden;
  }

  .progress-bar {
    height: 100%;
    width: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      colors.get(primary_50),
      transparent
    );
    animation: slide 2s ease-in-out infinite;
  }

  @keyframes slide {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
</style>

<script>
  import NotificationActions from "./NotificationActions.svelte";
  import NotificationIcon from "./NotificationIcon.svelte";
  import NotificationInfo from "./NotificationInfo.svelte";

  let { upload } = $props();
</script>

<div class="upload-item {upload?.viewed ? 'viewed' : ''}">
  <div class="upload-item-left">
    <NotificationIcon status={upload.status} />
    <NotificationInfo {upload} />
  </div>

  <NotificationActions {upload} />

  {#if upload.status === "processing"}
    <div class="progress-bar-container">
      <div class="progress-bar"></div>
    </div>
  {/if}
</div>
